import { Tooltip } from '@fasstech/middle-design-system';

const ErrorContainer = ({ children, hasError, errorTooltipMessage }) => {
  return hasError ? (
    <Tooltip variant={'centered'} text={errorTooltipMessage}>
      {children}
    </Tooltip>
  ) : (
    children
  );
};

export default ErrorContainer;
